import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

export default {
  namespaced: true,
  state () {
    return {
      list: [],
      selectedKey: undefined,
      selectedDocument: {
        documentNature: undefined,
        representationType: undefined,
        documentType: undefined,
        repositoryName: undefined,
        url: undefined,
        reference: undefined
      }
    }
  },
  mutations,
  actions,
  getters,
  modules: {

  }
}
